// @flow

import * as actions from 'client/constants/actions';

export function saveShareResult(params: { total: number, selected: number, description: string, itemId: string }) {
	return {
		type: actions.SAVE_SHARE_RESULT_TEXT,
		payload: { ...params },
	};
}
